import React from 'react';

import {
  SpecialFilterList,
  SpecialFilterItem,
} from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { getStockFilterParams } from '@/store/reducers/cars-stock';
import { getSpecialFilter } from '@/modules/CarsStock/components/common.helpers';

function SpecialFilter() {
  const stockFilterParams = useTypedSelector(getStockFilterParams);

  return (
    <SpecialFilterList>
      {stockFilterParams?.flags.map((item, index) => {
        const specialFilter = getSpecialFilter(item.id);

        return (
          <SpecialFilterItem key={index}>{specialFilter}</SpecialFilterItem>
        );
      })}
    </SpecialFilterList>
  );
}

export default SpecialFilter;
